// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3InSw","productName":"Table_productName__3oZfW"};